import { Button, Col, DatePicker, Flex, Form, Input, Radio, Row, Select, Upload } from 'antd'
import React from 'react'
import { t } from 'i18next'
import { UploadOutlined } from '@ant-design/icons'

export default function BoxSetupTab ({ form, owners, teleconsultingCompanies, displayTeleconsultingLogin, TCOnChange }) {
  const getFile = (e) => {
    if (Array.isArray(e)) {
      return e[0].originFileObj
    }
    return e && e.fileList[0].originFileObj
  }

  const beforeUpload = () => {
    return false
  }

  const pictureFileList = form.getFieldValue('picture_url')?.url
    ? [
        {
          url: form.getFieldValue('picture_url')?.url
        }
      ]
    : []

  const waitingTimeFileList = form.getFieldValue('waiting_time_url')?.url
    ? [
        {
          url: form.getFieldValue('waiting_time_url')?.url
        }
      ]
    : []

  return (
    <>
      <Flex justify='space-between'>
        <Flex vertical style={{ width: '23%' }}>
          <Flex justify='space-between' gap='10px'>
            <Form.Item name="name" label={t('Admin.BoxForm.name')} style={{ width: '-webkit-fill-available' }}
              rules={[{ required: true, message: t('rules.required') }]}>
              <Input />
            </Form.Item>
            <Form.Item name="short_code" label={t('Admin.BoxForm.shortCode')} style={{ width: '40%' }}
              rules={[{ required: true, message: t('rules.required') }]}>
              <Input />
            </Form.Item>
          </Flex>
          <Form.Item name="owner_id" label={t('Admin.BoxForm.owner')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Select
              showSearch={{
                optionFilterProp: 'children',
                filterOption: (input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }}
              placeholder="Selectionner un propriétaire"
              options={owners?.map((o) => ({ label: o.name, value: o.id }))}
            />
          </Form.Item>
          <Form.Item name="cleaning_slots_limit" label={t('Admin.BoxForm.cleaning_slots_limit')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input type="number" max="300" min="0" />
          </Form.Item>
        </Flex>
        <Flex vertical style={{ width: '23%' }}>
          <Flex justify='space-between'>
            <Form.Item name="active" label={t('Admin.Box.attributes.active')}>
              <Radio.Group
                options={[
                  { value: true, label: t('Admin.BoxForm.active') },
                  { value: false, label: t('Admin.BoxForm.inactive') }
                ]} />
            </Form.Item>
            <Form.Item name="opening_date" label={t('Admin.Box.attributes.openingDate')}>
              <DatePicker format={'DD/MM/YY HH[h]mm'} showTime={{ format: 'HH[h]mm' }} />
            </Form.Item>
          </Flex>
          <Form.Item name="slot_schedule" label={t('Admin.BoxForm.slot_schedule')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input type="number" max="59" min="0" />
          </Form.Item>
          <Form.Item name="cleaning_appointments_limit" label={t('Admin.BoxForm.cleaning_appointments_limit')}
            rules={[{ required: true, message: t('rules.required') }]}>
            <Input type="number" max="300" min="0" />
          </Form.Item>
        </Flex>
        <Row style={{ width: '50%', justifyContent: 'space-between' }}>
          <Col className='picture'>
            <Form.Item
              name="picture"
              label={t('Admin.BoxForm.picture')}
              getValueFromEvent={getFile}
            >
              <Upload name="picture"
                beforeUpload={beforeUpload}
                listType="picture"
                maxCount={1}
                defaultFileList={[...pictureFileList]}
                showUploadList={{ showRemoveIcon: false }}
                accept='.jpg,.png'>
                <Button icon={<UploadOutlined />}>{t('Admin.BoxForm.pictureButton')}</Button>
              </Upload>
            </Form.Item>
          </Col>
          <Col className='waiting-time'>
            <Form.Item
              name="waiting_time"
              label={t('Admin.BoxForm.waitingTime')}
              getValueFromEvent={getFile}
            >
              <Upload name="waiting_time"
                beforeUpload={beforeUpload}
                listType="picture"
                maxCount={1}
                defaultFileList={[...waitingTimeFileList]}
                showUploadList={{ showRemoveIcon: false }}
                accept='.jpg,.png'>
                <Button icon={<UploadOutlined />}>{t('Admin.BoxForm.pictureButton')}</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
      </Flex>
      <Flex vertical>
        <h4 style={{ marginTop: '0' }}>
          <a href='https://client-portal.prod.tessan.cloud/login' target='_blank' rel="noreferrer">
            {t('Admin.BoxForm.group.tessan')}
          </a>
        </h4>
        <Flex justify='space-between'>
          { teleconsultingCompanies &&
            <Form.Item name="teleconsulting_company_id" label={t('Admin.BoxForm.teleconsulting_company')}
              style={{ width: '22%' }}
              rules={[{ required: true, message: t('rules.required') }]}>
              <Select options={teleconsultingCompanies} onChange={TCOnChange} />
            </Form.Item>
          }
          {
            displayTeleconsultingLogin &&
            <>
              <Form.Item name="calendoc_id" label={t('Admin.BoxForm.calendoc_id')} style={{ width: '22%' }}>
                <Input />
              </Form.Item>
              <Form.Item name="tessan_login" label={t('Admin.BoxForm.tessan_login')} style={{ width: '22%' }}>
                <Input />
              </Form.Item>
              <Form.Item name="tessan_password" label={t('Admin.BoxForm.tessan_password')} style={{ width: '22%' }}>
                <Input.Password />
              </Form.Item>
            </>
          }
        </Flex>
      </Flex>
      <Flex vertical>
        <h4 style={{ marginTop: '0' }}>
          <a href='https://accounts.nordnet.com/' target='_blank' rel="noreferrer">
            {t('Admin.BoxForm.group.nordnet')}
          </a>
        </h4>
        <Flex justify='space-between' style={{ width: '30%' }}>
          <Form.Item name="nordnet_number" label={t('Admin.BoxForm.nordnet_number')}>
            <Input />
          </Form.Item>
          <Form.Item name="nordnet_email" label={t('Admin.BoxForm.nordnet_email')}>
            <Input />
          </Form.Item>
        </Flex>
      </Flex>
    </>
  )
}
